import Vue from 'vue';

import DateFilter from '../filters/DateFilter';
import NumberFilter from '../filters/NumberFilter';
import SliceFilter from '../filters/SliceFilter';
import CurrencyFilter from '../filters/CurrencyFilter';

Vue.use('date', DateFilter);
Vue.use('number', NumberFilter);
Vue.use('slice', SliceFilter);
Vue.use('currency', CurrencyFilter);
